{
  "schema_version": 1,
  "task_id": "L5-CREATIVE-FLOW-CLARITY-001",
  "status": "creative-flow-clarity-ready",
  "source_entry_point": "creative-flow-clarity",
  "generated_at": "2026-07-31T14:50:00+08:00",
  "authority_boundary": {
    "observational_only": true,
    "formal_gate_replacement": false,
    "mutation_authority": false,
    "approval_authority": false,
    "stores_user_decisions": false,
    "collects_secrets": false,
    "cloud_sync": false,
    "ecosystem_publish": false,
    "external_distribution": false,
    "external_write": false,
    "paid_action": false,
    "secret_storage": false,
    "deployment": false,
    "runtime_activation": false,
    "model_call": false,
    "tool_call": false,
    "task_completion_authority": false
  },
  "summary": {
    "runway_step_count": 6,
    "handoff_bridge_count": 5,
    "can_execute_now_count": 0,
    "external_effect_count": 0,
    "secret_values_embedded_count": 0,
    "remaining_user_decision_count": 3,
    "visible_capability": "creative-starter-readonly",
    "adds_new_visible_capability": false
  },
  "runway_steps": [
    {
      "id": "brief",
      "title_zh": "说出想法",
      "title_en": "Say the idea",
      "body_zh": "用户先用自然语言描述想创造什么；AIOS 只把它当作本地 Brief。",
      "body_en": "The user describes what they want to create; AIOS treats it only as a local brief.",
      "input_zh": "一句话目标",
      "input_en": "One-line goal",
      "output_zh": "Brief 草稿",
      "output_en": "Brief draft",
      "authority_state": "local-draft-only",
      "can_execute_now": false
    },
    {
      "id": "task_spec",
      "title_zh": "压成 Task Spec",
      "title_en": "Compress into Task Spec",
      "body_zh": "范围、非目标、验收、风险和回滚先成形，避免直接跳进编码或外部动作。",
      "body_en": "Scope, non-goals, acceptance, risks and rollback take shape before coding or external actions.",
      "input_zh": "Brief 草稿",
      "input_en": "Brief draft",
      "output_zh": "Task Spec 草稿",
      "output_en": "Task Spec draft",
      "authority_state": "draft-no-formal-gate",
      "can_execute_now": false
    },
    {
      "id": "intent_queue",
      "title_zh": "进入 Intent Queue",
      "title_en": "Enter Intent Queue",
      "body_zh": "任务意图可排队、可解释、可取消，但不会直接调用模型、GitHub、Runtime 或云。",
      "body_en": "The work intent becomes queued, explainable and cancellable without calling models, GitHub, Runtime or cloud.",
      "input_zh": "Task Spec 草稿",
      "input_en": "Task Spec draft",
      "output_zh": "本地意图卡",
      "output_en": "Local intent card",
      "authority_state": "queued-non-executing",
      "can_execute_now": false
    },
    {
      "id": "capability_route",
      "title_zh": "编排能力路线",
      "title_en": "Route capabilities",
      "body_zh": "Codex、LLM、Skill、GitHub、IDE、浏览器和云只被列为候选引擎与边界。",
      "body_en": "Codex, LLMs, Skills, GitHub, IDEs, browsers and cloud are only listed as candidate engines and boundaries.",
      "input_zh": "本地意图卡",
      "input_en": "Local intent card",
      "output_zh": "候选能力路线",
      "output_en": "Candidate capability route",
      "authority_state": "proposal-only",
      "can_execute_now": false
    },
    {
      "id": "preview",
      "title_zh": "先看作品预览",
      "title_en": "Preview the work first",
      "body_zh": "中心区域优先呈现作品雏形、结构和体验，而不是让用户盯着任务表。",
      "body_en": "The center shows the emerging work, structure and experience before task tables.",
      "input_zh": "候选能力路线",
      "input_en": "Candidate capability route",
      "output_zh": "Preview Lab 草图",
      "output_en": "Preview Lab sketch",
      "authority_state": "preview-only",
      "can_execute_now": false
    },
    {
      "id": "feedback",
      "title_zh": "反馈进入下一轮",
      "title_en": "Feedback enters next loop",
      "body_zh": "截图、感受和修改要求回流成下一轮 Task Spec，而不是散落在聊天记忆里。",
      "body_en": "Screenshots, feelings and change requests flow into the next Task Spec instead of staying in chat memory.",
      "input_zh": "体验反馈",
      "input_en": "Experience feedback",
      "output_zh": "下一轮任务意图",
      "output_en": "Next task intent",
      "authority_state": "feedback-capture-only",
      "can_execute_now": false
    }
  ],
  "handoff_bridges": [
    {
      "from": "brief",
      "to": "task_spec",
      "rule": "first-principles-scope-before-code"
    },
    {
      "from": "task_spec",
      "to": "intent_queue",
      "rule": "task-spec-before-effect"
    },
    {
      "from": "intent_queue",
      "to": "capability_route",
      "rule": "proposal-before-runtime"
    },
    {
      "from": "capability_route",
      "to": "preview",
      "rule": "preview-before-execution"
    },
    {
      "from": "preview",
      "to": "feedback",
      "rule": "user-experience-before-next-iteration"
    }
  ],
  "guardrails": [
    "no_execute_button",
    "no_runtime_activation",
    "no_external_write",
    "no_secret_collection",
    "no_model_fact_authority",
    "no_github_clone",
    "no_install",
    "evidence_reviewer_before_formal_gate"
  ],
  "quality_gates": [
    "Task Spec",
    "Evidence",
    "Reviewer",
    "Rollback",
    "lint/build/test",
    "no external effect"
  ],
  "handoff_integration": {
    "visible_capability": "creative-starter-readonly",
    "evidence": "artifacts/evidence/L5-CREATIVE-FLOW-CLARITY-001",
    "project_status": "config/aios-project-status.json",
    "final_handoff_pack": "config/l5-final-handoff-pack.json",
    "completion_map": "config/l5-completion-map.json"
  }
}
